const QueryKey = {
  TODOS: "todos",
  TODO: "todo",
  CATEGORIES: "categories",
  CATEGORY: "category",
  ACCOUNT_REGISTRATIONS: "account-registrations",
  ME: "me",
  TENANT_USERS: "tenant-users",
  VOICE_AGENTS: "voice-agents",
  VOICE_AGENT: "voice-agent",
  PUBLIC_VOICE_AGENT: "public-voice-agent",
  VOICE_AGENT_CLINICS: "voice-agent-clinics",
  VOICE_AGENT_CLINIC: "voice-agent-clinic",
  VOICE_AGENT_CLINIC_QA: "voice-agent-clinic-qa",
  CSV_PROCESSES: "csv-processes",
  CSV_PROCESS: "csv-process",
  CHATBOT_AGENTS: "chatbot-agents",
  CHATBOT_AGENT: "chatbot-agent",
  KNOWLEDGE: "knowledge",
  KNOWLEDGE_BASES: "knowledge-bases",
  KNOWLEDGE_BASE: "knowledge-base",
  KNOWLEDGE_FINAL: "knowledge-final",
  CHAT_SESSIONS: "chat-sessions",
  CHAT_SESSION: "chat-session",
  PUBLIC_CHATBOT: "public-chatbot",
  PUBLIC_GEMINI_CHATBOT: "public-gemini-chatbot",
  CHATBOT_SPREADSHEETS: "chatbot-spreadsheets",
  OWNER_TENANTS: "owner-tenants",
  OWNER_TENANT_USERS: "owner-tenant-users",
  OWNER_VOICES: "owner-voices",
  VOICE_GENERATIONS: "voice-generations",
  CRAWL_URL_PROCESS: "crawl-url-process",
  CRAWL_URL_PROCESSES: "crawl-url-processes",
  KNOWLEDGE_REVIEW: "knowledge-review",
  KNOWLEDGE_COMPILATIONS: "knowledge-compilations",
  COMPILED_KNOWLEDGE_ROWS: "compiled-knowledge-rows",
  CHATBOT_PRODUCTS: "chatbot-products",
  CHATBOT_PRONUNCIATION_RULES: "chatbot-pronunciation-rules",
  CHATBOT_PRONUNCIATION_RUNS: "chatbot-pronunciation-runs",
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];

export default QueryKey;
